import { sv } from "date-fns/locale/sv";

import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { useTranslation } from "react-i18next";

import themeColors from "../../constants/themeColors";

registerLocale("sv", sv);

export default function DateTime({ value, placeholder, dateFormat = "yyyy-MM-dd", ...props }) {
	const { i18n } = useTranslation();

	const { language } = i18n;

	const isTimeOnly = dateFormat === "HH:mm";

	return (
		<DatePicker
			locale={language}
			dateFormat={dateFormat}
			selected={value}
			timeIntervals={15}
			showTimeCaption={false}
			strictParsing
			placeholderText={placeholder}
			customInput={<input style={{ width: "100%" }} />}
			calendarContainer={({ children }) => {
				return (
					<div
						style={{
							display: "inline-block",
							background: themeColors.WHITE,
							border: `1px solid ${themeColors.GREY}`,
							borderRadius: 5,
							height: !isTimeOnly && 260,
							lineHeight: isTimeOnly && 2,
						}}
					>
						{children}
					</div>
				);
			}}
			showMonthDropdown
			showYearDropdown
			calendarStartDay={1}
			{...props}
		/>
	);
}
